/** Exact destinations decoded from the brand's supplied QR images, 26 October 2026. */
export const brandSocialLinks = [
  {
    id: 'instagram',
    label: 'Instagram',
    caption: '@kloth.iq',
    url: 'https://www.instagram.com/kloth.iq?utm_source=qr&igsh=Zm9jYzZzanRza2Rt',
    qr: '/brand-qr/instagram.png',
  },
  {
    id: 'community',
    label: 'WhatsApp community',
    caption: 'Join our community',
    url: 'https://chat.whatsapp.com/BSHIREkysL7B9B2FOnbZHc',
    qr: '/brand-qr/community.png',
  },
  {
    id: 'channel',
    label: 'WhatsApp channel',
    caption: 'Follow our updates',
    url: 'https://whatsapp.com/channel/0029Vb8hKbjKrWQq6le7R837',
    qr: '/brand-qr/channel.png',
  },
] as const;
